import React from 'react';
import { Provider } from 'react-redux';
import store from '@store/index';
import 'antd/dist/antd.less';
import { FontStyle } from './style';
import { I18nProvider } from './i18n';
import './i18n/i18n';

const App = ({ element }:{element:React.ReactElement }) => (
  <Provider store={store}>
    <I18nProvider>
      <FontStyle />
      <div id='webContent'>
        <div id='authing_root' />
        {element}
      </div>
    </I18nProvider>
  </Provider>
);

export default App;
